// src/lib/og-images.ts
// Centralized Open Graph image mapping for Frayze.
// GENERATED by scripts/og/wire.mjs from scripts/og/cards.mjs - edit there, not here.

export interface OgImageConfig {
  path: string;
  alt: string;
  width?: number;
  height?: number;
}

export const ogImageMap: Record<string, OgImageConfig> = {
  '/': {
    path: '/frayze-og-images/og-home.jpg',
    alt: 'Catch every lead. Live in 7 days. | Frayze',
    width: 1200,
    height: 630
  },
  '/about': {
    path: '/frayze-og-images/og-about.jpg',
    alt: 'The team behind the system. | Frayze',
    width: 1200,
    height: 630
  },
  '/contact': {
    path: '/frayze-og-images/og-contact.jpg',
    alt: 'Let\'s build your lead engine. | Frayze',
    width: 1200,
    height: 630
  },
  '/blog': {
    path: '/frayze-og-images/og-blog.jpg',
    alt: 'Insights for lead-driven businesses. | Frayze',
    width: 1200,
    height: 630
  },
  '/solutions': {
    path: '/frayze-og-images/og-solutions.jpg',
    alt: 'One system. Every lead caught. | Frayze',
    width: 1200,
    height: 630
  },
  '/solutions/ai-strategy-rollout': {
    path: '/frayze-og-images/og-ai-strategy.jpg',
    alt: 'Your AI rollout, done right. | Frayze',
    width: 1200,
    height: 630
  },
  '/solutions/crm-automation': {
    path: '/frayze-og-images/og-crm.jpg',
    alt: 'Your CRM, on autopilot. | Frayze',
    width: 1200,
    height: 630
  },
  '/solutions/lead-generation-system': {
    path: '/frayze-og-images/og-lead-gen.jpg',
    alt: 'Turn clicks into booked calls. | Frayze',
    width: 1200,
    height: 630
  },
  // web-design-local-seo split 2026-07-10: both successors reuse the og-web-seo card until bespoke cards ship
  '/solutions/websites': {
    path: '/frayze-og-images/og-web-seo.jpg',
    alt: 'Websites that convert browsers into leads. | Frayze',
    width: 1200,
    height: 630
  },
  '/solutions/local-seo-reputation': {
    path: '/frayze-og-images/og-web-seo.jpg',
    alt: 'Get found locally. Own your reviews. | Frayze',
    width: 1200,
    height: 630
  },
  '/solutions/ad-management-scale': {
    path: '/frayze-og-images/og-ads.jpg',
    alt: 'Ad spend that pays you back. | Frayze',
    width: 1200,
    height: 630
  },
  '/pricing': {
    path: '/frayze-og-images/og-pricing.jpg',
    alt: 'One system. No contracts. | Frayze',
    width: 1200,
    height: 630
  },
  '/website-launch-program': {
    path: '/frayze-og-images/og-launch.jpg',
    alt: 'Your website, live in 7 days. | Frayze',
    width: 1200,
    height: 630
  },
  '/resources': {
    path: '/frayze-og-images/og-resources.jpg',
    alt: 'Free tools to catch more leads. | Frayze',
    width: 1200,
    height: 630
  },
  '/platform': {
    path: '/frayze-og-images/og-platform.jpg',
    alt: 'Your whole business, one platform. | Frayze',
    width: 1200,
    height: 630
  },
  '/onboarding': {
    path: '/frayze-og-images/og-onboarding.jpg',
    alt: 'From signup to live in days. | Frayze',
    width: 1200,
    height: 630
  },
  '/faq': {
    path: '/frayze-og-images/og-faq.jpg',
    alt: 'Everything you need to know. | Frayze',
    width: 1200,
    height: 630
  },
  '/book-consultation': {
    path: '/frayze-og-images/og-book.jpg',
    alt: 'Book your free strategy call. | Frayze',
    width: 1200,
    height: 630
  },
  '/digital-audit': {
    path: '/frayze-og-images/og-digital-audit.jpg',
    alt: 'See where your leads leak. | Frayze',
    width: 1200,
    height: 630
  },
  '/careers': {
    path: '/frayze-og-images/og-careers.jpg',
    alt: 'Build the future of business AI. | Frayze',
    width: 1200,
    height: 630
  },
  '/automotive': {
    path: '/frayze-og-images/og-automotive.jpg',
    alt: 'AI growth systems for dealers. | Frayze',
    width: 1200,
    height: 630
  },
  '/automotive/dealers': {
    path: '/frayze-og-images/og-dealers.jpg',
    alt: 'The operating system for independent dealers. | Frayze',
    width: 1200,
    height: 630
  },
  '/automotive/gta-dealers': {
    path: '/frayze-og-images/og-gta-dealers.jpg',
    alt: 'Built for GTA dealers. | Frayze',
    width: 1200,
    height: 630
  },
  '/industries/trades': {
    path: '/frayze-og-images/og-trades.jpg',
    alt: 'Never miss another job. | Frayze',
    width: 1200,
    height: 630
  },
  '/service-areas/thunder-bay': {
    path: '/frayze-og-images/og-thunder-bay.jpg',
    alt: 'Thunder Bay\'s lead-system builders. | Frayze',
    width: 1200,
    height: 630
  },
  '/service-areas/sudbury': {
    path: '/frayze-og-images/og-sudbury.jpg',
    alt: 'Sudbury growth systems, done right. | Frayze',
    width: 1200,
    height: 630
  },
  '/canada-ai-strategy-small-business': {
    path: '/frayze-og-images/og-canada-ai.jpg',
    alt: 'The Ontario guide to AI automation. | Frayze',
    width: 1200,
    height: 630
  },
};

// Default fallback image (legal/util pages + any unmapped route).
export const defaultOgImage: OgImageConfig = {
    path: '/frayze-og-images/og-default.jpg',
    alt: 'AI automation, websites, CRM & lead systems. | Frayze',
    width: 1200,
    height: 630
};

// Get OG image config for a route (trailing slash + query tolerant).
export const getOgImageConfig = (routePath: string): OgImageConfig => {
  const normalizedPath = routePath.split('?')[0].replace(/\/$/, '') || '/';
  return ogImageMap[normalizedPath] || defaultOgImage;
};

// Absolute OG image URL (OG/Twitter images must be absolute, not relative).
export const getOgImageUrl = (routePath: string): string => {
  const config = getOgImageConfig(routePath);
  const encodedPath = config.path.split('/').map((segment) =>
    segment ? encodeURIComponent(segment) : segment
  ).join('/');
  return `https://frayze.ca${encodedPath}`;
};

// Twitter image (same as OG for consistency).
export const getTwitterImageUrl = (routePath: string): string => {
  return getOgImageUrl(routePath);
};
